// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__rp6Yx","summary":"CartItem_summary__ZJVVp","price":"CartItem_price__GE1UB","amount":"CartItem_amount__TLjvT","actions":"CartItem_actions__WAL6U"};